const WidgetType = {
  JsBallotBox: "jsballotbox",
  UserSite: "usersite",
};

export default WidgetType;
